import { Reference } from '@approvalmax/types';
import { NetSuiteContext } from 'pages/requestForm/data/netsuite/NetSuiteContext';
import { CreateNetSuiteVendor } from 'shared/data/webApp/v1';
import { z } from 'zod';

import { createSchema, getAddressLinesItem, subsidiaryItem } from './NetSuiteVendorCreationPopupContent.schema';

export type FormValues = z.infer<ReturnType<typeof createSchema>>;

export interface NetSuiteVendorCreationPopupContentProps {
    terms: Reference[];
    currencies: NetSuiteContext['currencies'];
    requestSubsidiary: Reference | null;
    onClose?: () => void;
    onSave?: (vendor: CreateNetSuiteVendor['response']['vendor']) => void;
}

export enum VendorType {
    Company = 'Company',
    Individual = 'Individual',
}

export type SubsidiaryTableItem = z.infer<typeof subsidiaryItem> & {
    id: string;
    index: number;
};

export type AddressLinesItem = z.infer<ReturnType<typeof getAddressLinesItem>>;

export type AddressLinesTableItem = AddressLinesItem & {
    id: string;
    index: number;
};
